// extracted by mini-css-extract-plugin
module.exports = {"infoContainer":"contact-module--infoContainer--GKnDb","formContainer":"contact-module--formContainer--1UyPd"};